import { Controller } from "@hotwired/stimulus";

// Markup: cada caixa com `data-grupo`, cada botão com `data-marcacao-grupo-param`.
// O contador soma só as caixas com `data-conta` e acende acima de `maximo`.
export default class extends Controller {
  static targets = ["caixa", "botao", "contador"];
  static values = { maximo: Number };

  connect() {
    this.sincronizar();
  }

  alternarGrupo({ params: { grupo } }) {
    const caixas = this.caixasDo(grupo);
    const marcar = !caixas.every((caixa) => caixa.checked);

    caixas.forEach((caixa) => {
      caixa.checked = marcar;
    });

    this.sincronizar();
  }

  sincronizar() {
    this.botaoTargets.forEach((botao) => {
      const todas = this.caixasDo(botao.dataset.marcacaoGrupoParam).every((caixa) => caixa.checked);

      botao.textContent = todas ? "Desmarcar todas" : "Marcar todas";
      botao.setAttribute("aria-pressed", todas.toString());
    });

    if (this.hasContadorTarget) this.contar();
  }

  contar() {
    const marcadas = this.caixaTargets.filter((caixa) => "conta" in caixa.dataset && caixa.checked).length;
    const passou = this.maximoValue > 0 && marcadas > this.maximoValue;

    this.contadorTarget.textContent = passou
      ? `${marcadas} marcadas, só as ${this.maximoValue} primeiras serão mostradas`
      : `${marcadas} de ${this.maximoValue} métricas marcadas`;
    this.contadorTarget.classList.toggle("gkg-checkgrid__contador--acima", passou);
  }

  caixasDo(grupo) {
    return this.caixaTargets.filter((caixa) => caixa.dataset.grupo === grupo);
  }
}
